import {
  FETCH_TICKETS_REQUEST,
  FETCH_TICKETS_SUCCESS,
  FETCH_TICKETS_FAILURE,
  FETCH_SPOTS_SUCCESS,
  UPDATE_TICKET_STATUS
} from "../actions/TicketActions";

const initialState = {
  tickets: [],
  count: 0,
  spots: [],
  loading: false,
  error: null
};

const TicketReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TICKETS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case FETCH_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: action.payload.tickets,
        count: action.payload.count,
        error: null
      };
    
    case FETCH_TICKETS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case FETCH_SPOTS_SUCCESS:
      return {
        ...state,
        spots: action.payload
      };
    
    case UPDATE_TICKET_STATUS:
      return {
        ...state,
        tickets: state.tickets.map(ticket =>
          ticket.id === action.payload.ticketId
            ? { 
                ...ticket, 
                is_used: action.payload.status === 'used' ? 1 : ticket.is_used,
                status: action.payload.status === 'cancelled' ? 'cancelled' : ticket.status
              }
            : ticket
        )
      };
    
    default:
      return state;
  }
};

export default TicketReducer;